export const formatLakhs = value => `₹${Number(value || 0).toFixed(2)}L`;
export const formatPercentage = value => `${Number(value || 0).toFixed(2)}%`;
export const formatNumber = value => Number(value || 0).toLocaleString("en-IN");
export const getTodayDate = () => new Date().toISOString().slice(0, 10);
export const subtractMonthsFromDate = (dateString, months) => {
  const date = new Date(dateString);
  date.setMonth(date.getMonth() - months);
  return date.toISOString().slice(0, 10);
};

export const getLastSevenDaysStartDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 6);
  return date.toISOString().slice(0, 10);
};

export const getViewTypeLabel = viewType => {
  switch (viewType) {
    case "my_enquiries":
      return "My Enquiries";
    case "company_enquiries":
      return "Company Enquiries";
    default:
      return viewType || "";
  }
};

export const getUserEmail = user => {
  if (typeof user === "string") return user;
  return user?.email || user?.user_email || "";
};

export const getOriginName = item => {
  if (typeof item === "string") return item;
  return item?.origin || "";
};

export const getLaneLabel = lane => {
  if (!lane) return "";

  if (typeof lane === "string") return lane;

  const origin = lane.origin || "";
  const destination = lane.destination || "";

  if (lane.lane) return lane.lane;
  if (origin && destination) return `${origin} - ${destination}`;

  return destination || origin || "";
};

export const getDestinationFromLane = lane => {
  if (!lane) return "";

  if (typeof lane === "string") {
    const parts = lane.split(" - ");
    return parts[1] || "";
  }

  return lane.destination || "";
};

export const shortEmail = email => {
  if (!email) return "";
  return email.split("@")[0];
};